/**
 * ZLoadingBar — Zephyr OS Design System
 *
 * Thin 2px indeterminate progress bar at top of content area.
 * No skeleton loaders. No shimmer. Just this.
 * Spec: design-system.md Section 7 (Loading States).
 */

export default function ZLoadingBar({ accent = '#6B35B8', loading = false }) {
  if (!loading) return null;

  return (
    <div style={{
      position: 'relative',
      width: '100%',
      height: 2,
      background: 'rgba(255,255,255,0.04)',
      borderRadius: 1,
      overflow: 'hidden',
    }}>
      <style>{`
        @keyframes z-loading-sweep {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(200%); }
        }
      `}</style>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '50%',
        height: '100%',
        background: accent,
        borderRadius: 1,
        animation: 'z-loading-sweep 1.5s ease-in-out infinite',
      }} />
    </div>
  );
}
